import { render, staticRenderFns } from "./ProfitCenterDepartment.vue?vue&type=template&id=a785337c&scoped=true&lang=pug&"
import script from "./ProfitCenterDepartment.vue?vue&type=script&lang=ts&"
export * from "./ProfitCenterDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a785337c",
  null
  
)

export default component.exports